import { HOME_ROUTE, STUDENT_TAGS_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { LayoutPages } from "../layoutPages";
import { StudentTagsWidget } from "../../widgets/studentTags";
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../entities/my";
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";

export default function StudentTagsPage() {

    const {my} = useAppSelector(s => s.myReducer)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.STUDENT_TAGS)
        && hasFeature(my, FEATURES.STUDENTS.TAGS_LIST)

    if(!isAccess){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={STUDENT_TAGS_ROUTE.name}>
            <StudentTagsWidget />
        </LayoutPages>
    )
}
